import moment from 'moment';
import React, { useState } from 'react';
import { getFormattedDate } from '../../../../common/services/common.service';
import { RotatingLines } from 'react-loader-spinner';

const PaymentDetails = ({ isLoading, enablePlaceOrder, leadDetails, quoteDetails, packageItem, handleSteps, handlePaymentInput, handlePayment, paymentSettings, handleBackSteps, paymentSelectedInput }: any) => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const startLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.start?.location?.address
  const endLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.end?.location?.address
  const pickupAddress = `${startLocation?.locality},${startLocation?.city},${startLocation?.state}-${startLocation?.area_code},${startLocation?.country}`
  const dropAddress = `${endLocation?.locality},${endLocation?.city},${endLocation?.state}-${endLocation?.area_code},${endLocation?.country}`

  const items = [
    {
      name: 'Cash',
      description: 'Cash on delivery',
      value: 10,
      checked: '',
      imageUrl: require('../../../../assets/img/cash.png'),
      show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelCOD,

    },
    {
      name: 'Online',
      description: 'Payment gateway',
      value: 20,
      checked: 'checked',
      imageUrl: require('../../../../assets/img/ccAvenue.png'),
      show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelOnline,
    },
    {
      name: 'Wallet',
      description: 'Wallet',
      value: 40,
      checked: '',
      imageUrl: require('../../../../assets/img/wallet.png'),
      show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,

    },
  ];


  return (
    <div className="flex flex-row justify-center  items-center  h-screen">
      <div className="overflow-auto h-[575px]  bg-white shadow-xl m-3 min-w-[400px]">
        <div className="flex flex-col justify-center items-start p-6 space-y-5">
          <div className='text-xl font-semibold '>Order Summary</div>
          <div className="w-full flex items-center justify-between p-2 border-b border-black">
            <div className="text-lg font-semibold ">
              Package Details
            </div>
            <div className="pl-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          <div className="w-full flex items-center justify-between">
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mx-2">
              <div className="pb-4">
                <label className="text-md font-semibold block">No of items added</label>
                <label className="text-base block mt-1">{quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.length}</label>
              </div>
              <div className="pb-4">
                <label className="text-md font-semibold block">Service Type</label>
                <label className="text-base block mt-1">{quoteDetails?.result?.Records[0]?.message?.order?.items[0]?.category_id}</label>
              </div>
              <div className="pb-4">
                <label className="text-md font-semibold block">Relocation Date</label>
                <label className="text-base block mt-1">
                  {quoteDetails?.result?.Records[0]?.message?.order ? quoteDetails?.result?.Records[0]?.message?.order?.items[0]?.time?.timestamp : moment().format('YYYY-MM-DD h:mm:ss a')}

                </label>
              </div>
              <div className="pb-4">
                <label className="text-md font-semibold block">Amount Quoted</label>
                <label className="text-base block mt-1">₹ {quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value}</label>
              </div>
            </div>


          </div>
          <div className="w-full flex items-center justify-between p-2 border-b border-black">
            <div className="text-lg font-semibold ">
              Address Details
            </div>
            <div className="pl-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-1 md:grid-cols-1 gap-4">
            <div className="mb-1 ">
              <label className="text-md font-semibold block">
                Pickup Address
              </label>
              <label className="text-base block mt-1">
                {pickupAddress}
              </label>
            </div>
            <div className="mb-1 ">
              <label className="text-md font-semibold block">
                Drop Address
              </label>
              <label className="text-base block mt-1">
                {dropAddress}
              </label>
            </div>
            <div className="mb-1 ">
              <label className="text-lg pr-5 font-semibold">
                Shipping Option
              </label>
              <label className="text-base ">
                {quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.type}
              </label>
            </div>

          </div>
        </div>
      </div>
      <div className="overflow-auto min-h-[575px] max-h-[600px] bg-white shadow-xl m-3 min-w-[900px]">
        <div className="flex flex-col justify-center items-start p-10 space-y-5">
          <div className='text-xl font-semibold '>Payment Details</div>
          <div className='text-md font-normal font-semibold p-3'>Payment Method</div>
          <div className='grid grid-cols-4 gap-4 w-full'>
            {items?.map((item: any, index: any) => (
              item.show && (
                <div className="flex flex-row items-center justify-start w-full" key={index}>
                  <input
                    name={item?.name}
                    type="radio"
                    placeholder=""
                    checked={paymentSelectedInput == String(item?.name)}
                    className={`mx-3 rounded bg-opacity-0 cursor-pointer transform scale-150`}
                    onChange={(event: any) => {
                      handlePaymentInput(event, item)
                      //   handleFormItemChange({
                      //     value: item?.name,
                      //     idx: index,
                      //     field: 'paymentType' // Changed field name to 'paymentType' for consistency
                      //   })
                    }}
                    value={item?.name}
                  />
                  <div className="text-xs font-light">
                    <img src={item?.imageUrl} alt={item?.name} className="h-24 w-24" />
                  </div>
                </div>
              )
            ))}

          </div>



          <div className='w-full flex justify-end px-10 space-x-3'>
            {/* <button
						onClick={handleBackSteps}
						className='px-4 py-2 bg-blue-900 text-white'>Back</button> */}

            <button
              onClick={handleSteps}
              className='px-4 py-2 bg-primary text-light'>Book later</button>

            {paymentSelectedInput == 'Cash' ?
              <button
                onClick={handlePayment}
                className={`${isLoading ? 'bg-disabled bg-primary  bg-opacity-80' : 'bg-primary '}
                         ${enablePlaceOrder ? 'bg-primary text-light cursor-pointer' : 'bg-disabled text-light'}
                         flex items-center justify-center px-4 py-2  relative`}
              >
                Place order
                <div
                  className={`absolute right-4 ${isLoading ? 'visible' : 'invisible'}`}
                >
                  <RotatingLines
                    visible={true}
                    width={'16'}
                    strokeColor="#fff"
                    strokeWidth="6"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              </button> :
              <button
                onClick={handlePayment}
                className={`${isLoading ? 'bg-disabled bg-primary bg-opacity-80' : 'bg-primary '}
                         ${enablePlaceOrder ? 'bg-primary text-light cursor-pointer' : 'bg-disabled text-light'}
                         flex items-center justify-center px-4 py-2 relative`}
              >
                Make a Payment
                <div
                  className={`absolute right-4 ${isLoading ? 'visible' : 'invisible'}`}
                >
                  <RotatingLines
                    visible={true}
                    width={'16'}
                    strokeColor="#fff"
                    strokeWidth="6"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                  />
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    </div >
  );
};

export default PaymentDetails;
